import { Suspense, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
    deleteItem,
    fetchPaginationData,
    updateStatus,
} from "../../../utils/apiUtils";

import DeleteModel from "../../../Components/DeleteModel";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../Components/Breadcrumb";
import Pagination from "../../../Components/Pagination";

import {
    ActionButton,
    checkImage,
    PlusButton,
    ToggleSwitch,
} from "../../../Components/TableHelper";

import { formatDate } from "../../../utils/constant";
import PerPageSelect from "../../../Components/PerPageSelect";

import {
    DragDropContext,
    Draggable,
    Droppable,
} from "react-beautiful-dnd";

const ClientType = () => {
    const [loading, setLoading] = useState(false);
    const [data, setdata] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [nextSortOrder, setNextSortOrder] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [perPage, setPerPage] = useState(25);
    const navigator = useNavigate();

    const fetchDataPagination = async (
        page = 1,
        currentPerPage = perPage
    ) => {
        const requestData = {
            perPage: currentPerPage,
            pageNo: page,
        };

        await fetchPaginationData(
            "clienttype/clienttype-pagination",
            requestData,
            setdata,
            setTotalCount,
            setCurrentPage,
            setLoading,
            setNextSortOrder
        );
    };

    useEffect(() => {
        fetchDataPagination(1);
    }, []);

    const handlePerPageChange = (value) => {
        setPerPage(value);
        fetchDataPagination(1, value);
    };

    const totalPages = Math.ceil(totalCount / perPage);

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchDataPagination(page);
        }
    };

    const handleDelete = async (item) => {
        setDeleteItemId(item);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsDeleting(true);

        try {
            const res = await deleteItem(
                "clienttype/deletetype",
                deleteItemId?._id,
                fetchDataPagination
            );

            setDeleteItemId({});
            setDeleteModalOpen(false);

            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (item) => {
        const updated = await updateStatus(
            item?._id,
            "clientType",
            "Client Type"
        );

        if (!updated) return;

        setdata((prev) =>
            prev.map((curr) =>
                curr._id === updated._id
                    ? {
                        ...curr,
                        isActive: updated.isActive,
                    }
                    : curr
            )
        );
    };

    const handleAdd = () => {
        navigator("/add-client-type", {
            state: {
                sortOrder: nextSortOrder,
            },
        });
    };

    const handleEditClick = (item) => {
        navigator("/add-client-type", {
            state: item,
        });
    };

    const Tableheader = [
        "Sort Order",
        "Image",
        "Client Type",
        "Is Active",
        "Updated At",
        "Action",
    ];

    const breadcrumbdata = [
        { label: "Home", path: "/dashboard" },
        { label: "Client Type", path: "/client-type" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header">
                    <h3 className="custom-page-title">
                        Client Type
                    </h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <PerPageSelect
                            value={perPage}
                            onChange={handlePerPageChange}
                        />
                    </div>

                    <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                    >
                        <PlusButton
                            handleAdd={handleAdd}
                            module="Client"
                        />
                    </div>
                </div>

                <div
                    className="row"
                    style={{ marginTop: "10px" }}
                >
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <DragDropContext>
                                    <Droppable droppableId="Clienttype">
                                        {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="table-responsive"
                                            >
                                                <table
                                                    className="custom-table table table-striped"
                                                    id="clienttable"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {Tableheader.map(
                                                                (item, index) => (
                                                                    <th
                                                                        className="font-weight-bold"
                                                                        key={index}
                                                                    >
                                                                        {item}
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td
                                                                    colSpan="12"
                                                                    className="text-center"
                                                                >
                                                                    <Spinner />
                                                                </td>
                                                            </tr>
                                                        ) : data?.length > 0 ? (
                                                            data.map(
                                                                (item, index) => {
                                                                    return (
                                                                        <Draggable
                                                                            key={item._id}
                                                                            draggableId={item._id.toString()}
                                                                            index={index}
                                                                        >

                                                                            {(provided) => (
                                                                                <tr
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    ref={provided.innerRef}
                                                                                >
                                                                                    <td>
                                                                                        {item?.sortOrder}
                                                                                    </td>
                                                                                    <td>
                                                                                        {item?.name}
                                                                                    </td>
                                                                                    <td>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="count-button1"
                                                                                            onClick={() =>
                                                                                                navigator(`/clients/${item?._id}`,
                                                                                                    {
                                                                                                        state: item,
                                                                                                    },
                                                                                                )
                                                                                            }
                                                                                        > {item?.clientCount || 0}
                                                                                        </button>
                                                                                    </td>
                                                                                    <td>
                                                                                        <ToggleSwitch
                                                                                            data={item}
                                                                                            name="isActive"
                                                                                            checked={item?.isActive}
                                                                                            handleStatusToggle={
                                                                                                handleStatusToggle
                                                                                            }
                                                                                            module="Client"
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        {formatDate(
                                                                                            item?.updatedAt
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        <ActionButton
                                                                                            data={item}
                                                                                            handleEditClick={
                                                                                                handleEditClick
                                                                                            }
                                                                                            handleDelete={
                                                                                                handleDelete
                                                                                            }
                                                                                            module="Client type"
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </Draggable>)
                                                                })
                                                        ) : (
                                                            <tr>
                                                                <td
                                                                    colSpan="12"
                                                                    className="text-center"
                                                                >
                                                                    <h5>
                                                                        No data found.
                                                                    </h5>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>)}
                                    </Droppable>
                                </DragDropContext>

                                {data?.length > 0 && (
                                    <div>
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageClick}
                                            perPage={perPage}
                                            totalCount={totalCount}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {deleteModalOpen && (
                <Suspense fallback={null}>
                    <DeleteModel
                        deleteModalOpen={deleteModalOpen}
                        setDeleteModalOpen={() =>
                            setDeleteModalOpen(
                                !deleteModalOpen
                            )
                        }
                        onConfirm={confirmDelete}
                        itemName="client type"
                        isDeleting={isDeleting}
                    />

                </Suspense>

            )}

        </>
    );
};

export default ClientType;